<div class="p-4">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="card-sub-heading">
      Update the prescription status as
      {{ props.item.receipt.status }}?
    </div>
    <button mat-icon-button [disabled]="isLoading" (click)="dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="formSubmit()">
    <div class="row py-2">
      <div class="col-md-12">

        <mat-checkbox class="example-margin bold mb-3" (change)="onCheckChange($event)" formControlName="NotifyUsers">
          Notify Users
        </mat-checkbox>

        <div class="row p-2" *ngIf="form.value.NotifyUsers">
          <div class="col-md-12">
            <div class="d-flex row">
              <ng-container formArrayName="NotifyUsersBy">
                <ng-container *ngFor="let item of notifyByArray.controls; let i = index">
                  <ng-container [formGroupName]="i">
                    <div class="col-md-4">
                      <mat-checkbox [value]="item.value.id" formControlName="isChecked" [disabled]="item.value.disable">
                        {{ item.value.value }}
                      </mat-checkbox>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- add track here -->
    <div class="row py-4">
      <div class="col-md-12">
        <mat-checkbox class="example-margin" formControlName="is_track">Add tracking information</mat-checkbox>
      </div>
    </div>
    <div class="row" *ngIf="isTrackVisible()">
      <div class="col-md-12">
        <div class="form-group">
          <input class="form-control" formControlName="track_url" placeholder="Enter track">
          <mat-error class="ml-3" *ngIf="
                form.controls['track_url'].touched &&
                form.controls['track_url'].hasError('required')
              ">
            Track URL is required
          </mat-error>
        </div>
      </div>
    </div>


    <ng-container *ngIf="!isReasonLoaded && isReasonStatus">
      <div class="d-flex align-items-center justify-content-center">
        <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
      </div>
    </ng-container>
    <ng-container *ngIf="isReasonLoaded">

      <div class="row mb-2">
        <div class="col-md-12" *ngIf="isReasonStatus">
          <label for="reasonList">Select Reason</label>
          <mat-form-field>
            <mat-select formControlName="reason_id" class="form-control w-100"
              placeholder="Select reason to {{ props.item.receipt.status }}">
              <mat-option *ngFor="let item of reasonList" [value]="item.id">
                {{ item?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-error-message [formName]="form" [fieldName]="'reason_id'" [type]="'group'">
          </app-error-message>
        </div>
      </div>
    </ng-container>
    <div class="row mb-2">
      <div class="col-md-12" *ngIf="isReasonStatus && showInternalNotes">
        <label for="reasonList">Notes</label>
        <textarea class="form-control height" formControlName="internal_notes"
          placeholder="Please enter notes for selected reason" rows="3"></textarea>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-md-12">
      </div>
    </div>
     
    <ng-container *ngIf="!isMessageLoaded && form.get('message')?.value != null">
      <div class="d-flex align-items-center justify-content-center">
        <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
      </div>
    </ng-container>
    <ng-container *ngIf="isMessageLoaded && form.get('message')?.value != null && isPatientMessage">
      <div class="row py-4" *ngIf="isCustomMessageVisible() && this.form.value.NotifyUsers">
        <div class="col-md-12">
          <mat-checkbox class="example-margin" formControlName="custom_message" (change)="onCheckMessage($event)">Automated chat</mat-checkbox>
        </div>
      </div>
      <div class="row" *ngIf="form.get('custom_message')?.value == true">
        <div class="col-md-12">
          <div class="form-group">
            <textarea class="form-control height" formControlName="message" placeholder="Custom message enter here..."
              rows="3"></textarea>
            <mat-error class="ml-3" *ngIf="
              form.controls['message'].touched &&
              form.controls['message'].hasError('required')
            ">
              Message is required
            </mat-error>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="row mt-4">
      <div class="col-md-12 d-flex align-items-end justify-content-end">
        <button class="custom-btn" [disabled]="isLoading" (click)="dialogRef.close()" type="button">
          Cancel
        </button>
        <!-- [disabled]="form.invalid" -->
        <button class="custom-btn" [disabled]="isLoading" type="submit">
          Confirm
          <span class="whiteLoader" *ngIf="isLoading"></span>
        </button>
      </div>
    </div>
  </form>
</div>
